var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, PropSync, Vue, Watch, } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var alert = namespace('Alert');
var AlertMessage = /** @class */ (function (_super) {
    __extends(AlertMessage, _super);
    function AlertMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertMessage.prototype.hide = function () {
        this.hideAlert();
    };
    AlertMessage.prototype.onUrlChange = function () {
        // Hide the alert box when user leaves the page.
        this.hide();
    };
    __decorate([
        PropSync('msg', { required: true, type: String })
    ], AlertMessage.prototype, "_msg", void 0);
    __decorate([
        alert.State
    ], AlertMessage.prototype, "isDisplaying", void 0);
    __decorate([
        alert.State
    ], AlertMessage.prototype, "content", void 0);
    __decorate([
        alert.Action
    ], AlertMessage.prototype, "hideAlert", void 0);
    __decorate([
        Watch('$route', { immediate: true, deep: true })
    ], AlertMessage.prototype, "onUrlChange", null);
    AlertMessage = __decorate([
        Component
    ], AlertMessage);
    return AlertMessage;
}(Vue));
export default AlertMessage;
